"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportBookmarkInfo = void 0;
var tslib_1 = require("tslib");
var list_1 = require("@devexpress/utils/lib/utils/list");
var string_1 = require("@devexpress/utils/lib/utils/string");
var import_bookmark_info_core_1 = require("./import-bookmark-info-core");
var ImportBookmarkInfo = (function (_super) {
    tslib_1.__extends(ImportBookmarkInfo, _super);
    function ImportBookmarkInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImportBookmarkInfo.prototype.validate = function (subDocument) {
        if (!this.skipNameValidation && !this.validateBookmarkName(subDocument))
            return false;
        return _super.prototype.validate.call(this, subDocument);
    };
    ImportBookmarkInfo.prototype.validateBookmarkName = function (subDocument) {
        var _this = this;
        return string_1.StringUtils.isNullOrEmpty(this.name) ?
            false :
            !list_1.ListUtils.elementBy(subDocument.bookmarks, function (bm) { return bm.name == _this.name; });
    };
    return ImportBookmarkInfo;
}(import_bookmark_info_core_1.ImportBookmarkInfoCore));
exports.ImportBookmarkInfo = ImportBookmarkInfo;
